var $body = $('body'),
	$waku = $('.waku'),
	$cursor = $('#cursor'),
	gowhere,
	ancho = $cursor.width(),
	alto = $cursor.height(),
	hoverActive = 0;



$body.mousedown(function(e){

	$cursor.addClass('clicked');

});

function MyAddClass(el){
	el.classList.add('open');
}


$(document).ready(function(){

	// -_-_-_-_-_-_-_-_-_-_-_-_ Page Opening Animation -_-_-_-_-_-_-_-_-_-_-_-_

	$('body').addClass('showTime');

	if($('#skirt').length){
		setTimeout(function(){
			$('#skirt').remove();
		},3000);
	}
	ScrollReveal().reveal(
		'.imgSkirt', 
		{ afterReveal: MyAddClass }
	);
});